import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      hasAvailableFranchiseesStoreOption: 'companiesCompany/hasAvailableFranchiseesStoreOption',
      hasAvailableUserCompanyStoreOption: 'companiesCompany/hasAvailableUserCompanyStoreOption',
      hasAvailableAreaStoreOption: 'companiesCompany/hasAvailableAreaStoreOption',
      hasVisibleStores: 'companiesStores/hasVisibleStores',
      analyzableSurveys: 'companiesCustomSurveySurveys/analyzableSurveys',
      isEmptyStores: 'companiesStores/isEmpty',
      hasReadableCompetitors: 'companiesCompany/hasReadableCompetitors',
    }),
    notAvailableType() {
      if (this.$route.path.includes('/analysis/')) {
        if (this.isEmptyStores) return 'emptyStore'
        const inFranchiseeAnalysis = this.crossSearchField?.fields === 'franchisee_id' || this.pageType?.fields === 'franchisee_id'
        const inUserCompanyAnalysis = this.crossSearchField?.fields === 'user_company_id' || this.pageType?.fields === 'user_company_id'
        const inAreaAnalysis = this.crossSearchField?.fields === 'area_id' || this.pageType?.fields === 'area_id'
        if (inFranchiseeAnalysis && !this.hasAvailableFranchiseesStoreOption) {
          return 'emptyFranchisee'
        } else if (inUserCompanyAnalysis && !this.hasAvailableUserCompanyStoreOption) {
          return 'emptyUserCompany'
        } else if (inAreaAnalysis && !this.hasAvailableAreaStoreOption) {
          return 'emptyArea'
        } else if (this.$route.path.includes('/analysis/visitors') && !this.hasVisibleStores) {
          return 'disableStorePage'
        } else if (this.$route.path.includes('/analysis/surveys') && this.analyzableSurveys.length === 0) {
          return 'disableSurvey'
        } else if ((this.$route.path.includes('/analysis/keywords')
          || this.$route.path.includes('/analysis/reviews')
          || this.$route.path.includes('/analysis/qscas/detail')) && !this.hasReadableCompetitors) {
          return 'emptyCompetitor'
        }
      }

      return null
    },
  },
}
